import {
	RESET_STATE,
	SET_ORDERS_WAYS_INFO,
	SET_IS_ORDERS_WAYS_DELETING,
	SET_IS_ORDERS_WAYS_INFO_LOADING,
	SET_IS_ORDERS_WAYS_SAVING,
	SET_GROUP_ID_LIST,
	SET_IS_CARRIERS_LIST_LOADING,
} from './actions';

export const initialState = {
	ordersWaysInfo: null,
	isOrdersWaysInfoLoading: false,
	isOrdersWaysDeleting: false,
	isOrdersWaysSaving: false,
	groupList: [],
	isCarriersListLoading: false,
};

const ordersWaysModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ORDERS_WAYS_INFO:
			return {
				...state,
				ordersWaysInfo: payload,
			};
		case SET_IS_ORDERS_WAYS_INFO_LOADING:
			return {
				...state,
				isOrdersWaysInfoLoading: payload,
			};
		case SET_IS_ORDERS_WAYS_DELETING:
			return {
				...state,
				isOrdersWaysDeleting: payload,
			};
		case SET_IS_ORDERS_WAYS_SAVING:
			return {
				...state,
				isOrdersWaysSaving: payload,
			};
		case SET_GROUP_ID_LIST:
			return {
				...state,
				groupList: payload,
			};
		case SET_IS_CARRIERS_LIST_LOADING:
			return {
				...state,
				isCarriersListLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default ordersWaysModalReducer;
